import Cookies from 'js-cookie'

import actions from './actions'
import mutations from './mutations'

const app = {
    state: {
        device: 'desktop',
        language: Cookies.get('language') || 'ru',
        token: Cookies.get('token'),
        fb: null,
        google: null,
        type: null,
        isShowMail: false,
        user: {
            firstName: null,
            lastName: null,
            phoneNumber: null,
            taxId: null,
            cardNumber: null,
            promoBalance: null,
            autoPromoBalance: null
        },
        isAccountConfirmed: false,
        completedAccounts: [],
        completedBrands: [],
        completedEstablishments: []
    },
    mutations,
    actions
}

export default app
